import React from 'react';

import { SwipeableViewsContainer as SwipeableViews } from '../containers/SwipeableViews';
import { Slide } from './Slide';

interface Children {
  // the slide index
  index: number;
}

interface Props {
  children: (props: Children) => React.ReactNode | null;
  disabled?: boolean;
}

const Slides: React.FC<Props> = ({ children, disabled }) => {
  return (
    <SwipeableViews
      disabled={disabled}
      style={{ height: '100%' }}
      containerStyle={{ height: '100%' }}
      slideRenderer={({ index, key }) => {
        return <Slide key={key}>{children({ index })}</Slide>;
      }}
    />
  );
};

export { Slides };
